var _excluded = ["children", "split"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { styled } from '@mui/material';
import * as React from 'react';
import { List } from '../../List';
import { jsx as _jsx } from "react/jsx-runtime";
var SideNavContext = /*#__PURE__*/React.createContext({
  level: 0,
  split: false
});
export var useSideNavContext = function useSideNavContext() {
  return React.useContext(SideNavContext);
};
var Root = styled(List, {
  label: 'MnrlSideNavMenu-root'
})(function (_ref) {
  var level = _ref.ownerState.level,
      theme = _ref.theme;
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(level === 0 ? 2 : 1),
    marginTop: theme.spacing(1)
  };
});
export var SideNavMenu = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      splitProp = _ref2.split,
      restProps = _objectWithoutPropertiesLoose(_ref2, _excluded);

  var _useSideNavContext = useSideNavContext(),
      level = _useSideNavContext.level,
      splitCtx = _useSideNavContext.split;

  var split = splitCtx;

  if (splitProp !== undefined) {
    if (level > 0) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('SideNavMenu: `split` may only be set on top-most menu');
      }
    } else {
      split = splitProp;
    }
  }

  var ownerState = {
    level: level
  };
  return /*#__PURE__*/_jsx(Root, _extends({
    component: level === 0 ? 'nav' : 'div',
    disablePadding: true,
    ref: ref,
    ownerState: ownerState
  }, restProps, {
    children: /*#__PURE__*/_jsx(SideNavContext.Provider, {
      value: {
        level: level + 1,
        split: split
      },
      children: children
    })
  }));
});